export default "__VITE_ASSET__BIRBSYLm__"